module.exports = __webpack_public_path__ + "img/hero-1.6774bce6.jpeg";